import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NbMenuItem, NbMenuService, NbSidebarService } from "@nebular/theme";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { logout } from "../../app.actions";
import { AppState, QueueItem, UserInfo } from "../../app.models";
import { DateTimePipe } from "../pipes/DateTimePipe";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() users = {
    name: "",
    title: "",
  };

  contractSelectItems: NbMenuItem[] = [];
  profileMenuItems: NbMenuItem[] = [];

  clientInfo: any;

  menu$: Subscription;
  contract$: Subscription;
  userInfo$: Subscription;
  selectedContractName: string;
  stage: string;
  selectedContract: string;
  queue$: Subscription;
  queue: QueueItem[];
  readyState: number;

  constructor(
    private nbMenuService: NbMenuService,
    private sidebarService: NbSidebarService,
    private router: Router,
    private store: Store,
    private date: DateTimePipe
  ) {
    this.stage = environment.production ? "" : "stage";
    this.users = {
      name: null,
      title: null,
    };
  }

  toggle() {
    this.sidebarService.toggle(true, "right");
    // https://github.com/swimlane/ngx-datatable/issues/923#issuecomment-377803539
    setTimeout(() => window.dispatchEvent(new Event("resize")));
  }

  ngOnInit() {
    this.userInfo$ = this.store
      .select((state: AppState) => state.userInfo)
      .subscribe((userInfo: UserInfo) => {
        this.users.name = userInfo.attributes.email;
        this.profileMenuItems = [
          { title: `Logout  (${this.users.name})`, link: "", data: "logout" },
        ];
      });

    this.contract$ = this.store
      .select((state: AppState) => state.contract)
      .pipe(filter((c) => !!c.selectedContract))
      .subscribe(({ contracts, selectedContract }) => {
        const menuItems = contracts.map((e) => ({
          data: e,
          title: e.name,
          icon: null,
        }));
        const current = menuItems.filter(
          (e) => e.data.clientId === selectedContract
        );
        //console.log(current)
        if (current) {
          current.forEach((i) => (i.icon = "checkmark-outline"));
        }
        this.contractSelectItems = [...menuItems];
        this.selectedContractName = contracts.find(
          (c) => c.clientId === selectedContract
        )?.name;
        this.selectedContract = selectedContract;
      });

    this.menu$ = this.nbMenuService
      .onItemClick()
      .pipe(filter(({ tag }) => tag === "contract-select" || tag === "profile"))
      .subscribe((menuBag) => {
        if (menuBag.item.data === "logout") {
          this.store.dispatch(logout());
        } else if (menuBag.item.data) {
          const { clientId } = menuBag.item.data;
          const { product } = menuBag.item.data;
          if (product === "analytics") {
            window.location.href = `${
              environment.analyticsDashboardUrl
            }?clientId=${encodeURIComponent(clientId)}`;
          } else {
            this.router.navigate([`/${clientId}/home`]);
          }
        }
      });

    this.queue$ = this.store
      .select((state: AppState) => state.queue)
      .subscribe((q) => {
        const qDeep = JSON.parse(JSON.stringify(q));
        this.queue = qDeep
          .reverse()
          .slice(0, 3)
          .map((e) => {
            let title = this.date.transform(e.time);
            // set title from json payload string
            try {
              title += " " + JSON.parse(e.pushPayload.payload).title;
            } catch (error) {}
            return { ...e, title };
          });
        this.readyState =
          this.queue.reduce((prev, curr) => prev + curr.readyState, 0) /
          this.queue.length;
      });
  }

  ngOnDestroy() {
    this.menu$.unsubscribe();
    this.contract$.unsubscribe();
    this.userInfo$.unsubscribe();
    this.queue$.unsubscribe();
  }
}
